// extracted by mini-css-extract-plugin
module.exports = {"content_wrapper":"_3mBOcpoOtb2PurJs2OUR3y"};